/**
 * created by xcc
 * 环境检测
 */

import React, {Component} from 'react';
import {Table, Pagination, message, Button} from 'antd';
import {HEADER_HEIGHT} from "../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {getMonitorListData, getStartMonitorData} from "../../actions/environmentalMonitoring"

class EnvironmentalMonitoring extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: 1, //当前页
            size: 10, //每页条数
            dataList: [], //数据源,
            listTotal: 0, //列表总数
            initialStatus: 0
        };
    }

    componentDidMount() {
        this.monitorListData();
    }

    monitorListData() {
        getMonitorListData({}, (res) => {
            console.log(res);
            let initialStatus = 0;
            let keyValue = 0;
            let dataList = [];
            if (res && res.data.list && res.data.status) {
                initialStatus = res.data.status;
                dataList = res.data.list;
                dataList.forEach((item, index) => {
                    keyValue = keyValue + 1;
                    let key = {key: keyValue};
                    dataList[index] = Object.assign(dataList[index], key);
                })
            }
            let start = this.state.size * this.state.start - this.state.size;
            let end = this.state.size * this.state.start;
            dataList.slice(start, end);
            console.log(dataList);
            this.setState({
                initialStatus,
                dataList,
                listTotal: dataList.length
            })
        })
    }

    startCheck = () => {
        getStartMonitorData({}, (res) => {
            console.log(res);
            if (res.data.result) {
                // let timer = setInterval(() => {
                    this.monitorListData();
                    if (this.state.initialStatus === 2) {
                        message.success("检测成功");
                        // clearInterval(timer);
                    } else if (this.state.initialStatus === 1) {
                        message.success("正在检测");
                    } else {
                        message.success("检测失败");
                    }
                // }, 1000)
            } else {
                message.error("检测失败");
            }
        })
    }

    render() {
        let newSecondSelectColor =
            this.props.config && this.props.config.getValueByKey
                ? this.props.config.getValueByKey("newSecondSelectColor", "#1E9FFF")
                : "#1E9FFF";
        let height = window.innerHeight - HEADER_HEIGHT; //上部分70//
        return (
            <div style={{margin: "20px"}}>
                <div
                    style={{
                        backgroundColor: "#fff",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "42px",
                            lineHeight: "42px",
                            padding: "0 15px",
                            borderBottom: "1px solid #f6f6f6",
                            color: newSecondSelectColor,
                            borderRadius: "2px 2px 0 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                        }}
                    >
                        环境检测
                    </div>
                    <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                        <div style={{padding: "15px 15px 0px 0px"}}>
                            <Button onClick={this.startCheck}
                                    style={{backgroundColor: newSecondSelectColor, borderColor: newSecondSelectColor}}
                                    type="primary">开始检测</Button>
                        </div>
                    </div>
                </div>
                {/* 检测列表 */}
                {/* 处理滚动条的方法以及自适应 */}
                <div style={{height: height - 175, background: "white", width: "100%"}}>
                    <Scrollbars>
                        <EnvironmentalMonitoringList dataList={this.state.dataList}
                                                     newSecondSelectColor={newSecondSelectColor}
                                                     ref={(c) => this.NewsApplyEdits = c}
                        />
                    </Scrollbars>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "10px",
                    }}
                >
                    <Pagination
                        showQuickJumper
                        current={this.state.start}
                        pageSize={this.state.size}
                        total={this.state.listTotal}
                        showTotal={(total) => `共 ${total} 条`}
                        showSizeChanger
                        onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
                        onShowSizeChange={(page, pageSize) => {
                            this.onChange(page, pageSize); //每页条数改变回调
                        }}
                    />
                </div>
            </div>
        );
    }

    onChange = (page, pageSize) => {
        this.state.start = page;
        this.state.size = pageSize;
        this.monitorListData();
    };
}

//列表数据
class EnvironmentalMonitoringList extends Component {
    static defaultProps = {
        newSecondSelectColor: '#0050B3',
    };
    static propTypes = {
        dataList: PropTypes.array.isRequired,//数据源
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        // 列
        const columns = [
            {
                key: '1',
                title: '名称',
                dataIndex: 'monitorName',
                width: "20%",
                ellipsis: true,
                align: "center",
                textWrap: 'word-break',
                render: (value, row, index) => {
                    return (
                        <div style={{
                            cursor: "pointer",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineClamp: 1,
                            whiteSpace: "nowrap"
                        }}>
                            {row.Name}
                        </div>
                    )
                }
            },
            {
                key: '2',
                title: "检测描述",
                dataIndex: 'monitorDescription',
                textWrap: 'word-break',
                width: "35%",
                ellipsis: true,
                align: "center",
                render: (value, row, index) => {
                    return (
                        <div style={{overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap"}}>
                            {row.Description}
                        </div>
                    )
                }
            },
            {
                key: '3',
                title: "检测状态",
                dataIndex: "monitorStatus",
                width: "15%",
                align: "center",
                ellipsis: true,
                textWrap: 'word-break',
                render: (value, row, index) => {
                    return (
                        <div style={{overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap"}}>
                            {
                                this.state.initialStatus === 0 ? "未检测" :
                                    (() => {
                                        switch (row.Status) {
                                            case 0:
                                                return "未检测";
                                                break;
                                            case 1:
                                                return "正在检测";
                                                break;
                                            case 2:
                                                return "检测完成";
                                                break;
                                        }
                                    })()
                            }
                        </div>
                    )
                }
            },
            {
                key: '4',
                title: '检测结果',
                dataIndex: "monitorResult",
                width: "15%",
                align: "center",
                ellipsis: true,
                textWrap: 'word-break',
                render: (value, row, index) => {
                    return (
                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineClamp: 1,
                            whiteSpace: "nowrap",
                            color: row.Result ? this.props.newSecondSelectColor : "red"
                        }}>
                            {row.Status === 2 ? row.Result ? "检测成功" : "检测失败" : ""}
                        </div>
                    )
                }
            },
            {
                key: '5',
                title: '错误信息',
                dataIndex: "errorInfo",
                width: "15%",
                align: "center",
                ellipsis: true,
                textWrap: 'word-break',
                render: (value, row, index) => {
                    return (
                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineClamp: 1,
                            whiteSpace: "nowrap",
                            color: row.Result ? this.props.newSecondSelectColor : "red"
                        }}>
                            {row.Error}
                        </div>
                    )
                }
            }
        ];

        return (
            <div>
                <div style={{width: "100%"}}>
                    <Table rowKey={record => record.id} style={{width: "100%"}} columns={columns}
                           dataSource={this.props.dataList} pagination={false}/>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}


export default (connect(mapStateToProps)(EnvironmentalMonitoring));
